<template>
  <div
    :class="
      $store.state.screenMode === 'dark'
        ? 'dark'
        : '' || $store.state.screenMode === 'light'
        ? 'light'
        : ''
    "
  >
    <div class="navContainer">
      <!--Navigation for desktop-->
      <nav v-if="!isOnMobileSize" class="desktopNav">
        <section>
          <DarkLightModeSwitch />
          <ul>
            <h1 id="title" v-if="!isOnMobileSize">
              <a @click="$router.push($store.state.routing.startPage)"
                >MARKETING<br />TOOLBOX</a
              >
            </h1>
            <!--Categories-->

            <div class="allNavItems">
              <section
                v-for="category in categories"
                class="navitem"
                :key="category"
              >
                <div class="dropdown">
                  <button
                    @click="onClickCategory($event, category)"
                    class="btn d-flex justify-content-between categoryBtn"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div>
                      <!-- <img
                    :src="category[category.active ? 'categoryIconActive': 'categoryIconNonActive']
                    "
                    :alt="category.categoryTitle"
                  />{{ category.categoryTitle }} -->
                      <img
                        class="defaultItem"
                        :src="
                          category[
                            $store.state.screenMode === 'dark'
                              ? 'categoryIconActive'
                              : 'categoryIconNonActive'
                          ]
                        "
                        :alt="category.categoryTitle"
                      />
                      <img
                        class="activeItem"
                        v-if="$store.state.screenMode === 'light'"
                        :src="category['categoryIconActive']"
                        :alt="category.categoryTitle"
                      />{{ category.categoryTitle }}
                    </div>
                    <i
                      class="fa-thin fa-angle-down mb-auto mt-auto"
                      v-if="subdivisionsArePresent(category)"
                    ></i>
                  </button>
                  <div
                    v-if="subdivisionsArePresent(category)"
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                    onclick="event.stopPropagation()"
                  >
                    <button
                      class="dropdown-item"
                      @click="onClickCategory($event, category)"
                      v-for="subdivision in category.subdivisions"
                      :key="subdivision"
                    >
                      <img
                        :src="
                          subdivision[
                            $store.state.screenMode === 'dark'
                              ? 'categoryIconActive'
                              : 'categoryIconNonActive'
                          ]
                        "
                        :alt="subdivision.subcategoryTitle"
                      />{{ subdivision.subcategoryTitle }}
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </ul>
        </section>
        <section>
          <ul class="pt-5">
            <!--Dasboard & Settings-->
            <section class="mb-4">
              <button
                class="btn extraBtns"
                @click="onClickCategory($event)"
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  src="@/assets/dashboard-w.svg"
                  alt="dashboardIcon"
                  v-if="$store.state.screenMode === 'dark'"
                />
                <img
                  v-else
                  src="@/assets/dashboard.svg"
                  alt="dashboardIconWhite"
                />Favorites
              </button>
              <!-- <button
              class="btn extraBtns"
              type="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src="@/assets/instellingen-w.svg"
                v-if="$store.state.screenMode === 'dark'"
                alt="settingsIconWhite"
              />
              <img
                src="@/assets/instellingen.svg"
                v-else
                alt="settingsIcon"
              />Instellingen
            </button> -->
            </section>
            <LoginPartial id="login" />
          </ul>
        </section>
      </nav>

      <!--Navigation for mobile-->
      <nav
        class="navbar navbar-expand-lg navbar-light mobileNav"
        v-if="isOnMobileSize"
      >
        <DarkLightModeSwitch v-if="isOnMobileSize" />
        <a
          class="navbar-brand mt-auto mb-auto"
          href="#"
          @click="$router.push($store.state.routing.startPage)"
          id="mobileTitle"
          >MARKETING TOOLBOX</a
        >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span style="color: white" class="my-1 mx-2 close">X</span>
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          class="collapse navbar-collapse mobileNav"
          id="navbarSupportedContent"
          v-if="isOnMobileSize"
        >
          <ul class="navbar-nav mr-auto">
            <section
              v-for="category in categories"
              class="navitem"
              :key="category"
            >
              <div class="dropdown">
                <button
                  @click="onClickCategory($event, category)"
                  class="btn d-flex justify-content-between categoryBtn"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div>
                    <img
                      :src="
                        category[
                          $store.state.screenMode === 'dark'
                            ? 'categoryIconActive'
                            : 'categoryIconNonActive'
                        ]
                      "
                      :alt="category.categoryTitle"
                    />{{ category.categoryTitle }}
                  </div>
                  <i
                    class="fa-thin fa-angle-down mb-auto mt-auto"
                    v-if="subdivisionsArePresent(category)"
                  ></i>
                </button>
                <div
                  v-if="subdivisionsArePresent(category)"
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                  onclick="event.stopPropagation()"
                >
                  <button
                    class="dropdown-item"
                    @click="onClickCategory($event, category)"
                    v-for="subdivision in category.subdivisions"
                    :key="subdivision"
                  >
                    <img
                      :src="
                        subdivision[
                          $store.state.screenMode === 'dark'
                            ? 'categoryIconActive'
                            : 'categoryIconNonActive'
                        ]
                      "
                      :alt="subdivision.subcategoryTitle"
                    />{{ subdivision.subcategoryTitle }}
                  </button>
                </div>
              </div>
            </section>
            <ul class="pt-5">
              <!--Favorites-->
              <section class="mb-4">
                <button
                  class="btn extraBtns"
                  @click="onClickCategory($event)"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    src="@/assets/dashboard-w.svg"
                    alt="dashboardIcon"
                    v-if="$store.state.screenMode === 'dark'"
                  />
                  <img
                    v-else
                    src="@/assets/dashboard.svg"
                    alt="dashboardIconWhite"
                  />Favorites
                </button>
                <!-- <button
              class="btn extraBtns"
              type="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src="@/assets/instellingen-w.svg"
                v-if="$store.state.screenMode === 'dark'"
                alt="settingsIconWhite"
              />
              <img
                src="@/assets/instellingen.svg"
                v-else
                alt="settingsIcon"
              />Instellingen
            </button> -->
              </section>
              <LoginPartial id="login" />
            </ul>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import LoginPartial from "@/components/StartScreen/Templates/Footer/LoginPartial";
import DarkLightModeSwitch from "@/components/Home/DarkLightMode/DarkLightModeSwitch";
export default {
  name: "Navigation",
  components: { LoginPartial, DarkLightModeSwitch },
  props: {
    social: Object,
    categories: Object,
  },
  computed: {
    getScreenMode() {
      return this.$store.state.screenMode;
    },
  },
  data() {
    return {
      mode: "light",
      isOnMobileSize: false,
      selectedCategory: {},
      dropdownIsOpen: false,
    };
  },
  methods: {
    resizeHandler(e) {
      if (window.innerWidth <= 992) this.isOnMobileSize = true;
      else this.isOnMobileSize = false;
    },
    onClickCategory($event, category) {
      this.selectedCategory = category;

      this.$store.state.searchedString = "";
      this.$router.replace("/Home");
      this.$emit("clicked", $event.target.innerText);

      // let img = $event.target.getElementsByTagName("img")[0];
      let dropdownbtn = document.querySelector("button.navbar-toggler");
      if (dropdownbtn === null) return;
      //Check if subdivision is clicked
      for (let category of this.categories) {
        if (category.subdivisions !== undefined) {
          for (let subdiv of category.subdivisions) {
            if (
              this.isOnMobileSize &&
              subdiv.subcategoryTitle === $event.target.innerText
            ) {
              dropdownbtn.click();
            }
          }
        }
      }

      let btns = document.querySelectorAll(".categoryBtn");

      for (let btn of btns) {
        if (btn === document.activeElement) {
          let img = btn.getElementsByTagName("img")[0];

          if (img.src === category["categoryIconNonActive"]) {
            img.src = category["categoryIconNonActive"];
          } else {
            img.src = category["categoryIconActive"];
          }
        }
      }

      // // This works only if the dropdown opens for the first time
      // category.active = !category.active;
      this.searchedString = "";
    },
    subdivisionsArePresent: function (category) {
      if (category.subdivisions) {
        if (category.subdivisions.length > 0) {
          return true;
        }
      }
    },
  },
  unmounted() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  beforeMount() {
    window.addEventListener("resize", this.resizeHandler);
    this.resizeHandler();
  },
  mounted() {
    //Using timeout to make sure categories are loaded and clickable.
    //Without this, it would cause some categories to not open.
    setTimeout(() => {
      let firstCategory = document.querySelectorAll(
        "button.btn.d-flex.justify-content-between.categoryBtn"
      )[0];

      if (
        (firstCategory !== undefined &&
          this.$store.state.searchedString === "") ||
        !this.$router.currentRoute._value.fullPath.includes("?q=")
      ) {
        firstCategory.click();
        firstCategory.click(); //Triggers the first category -> results show (this is to prevent empty results at page landing)
      }
    }, 800);
  },
};
</script>


<style scoped>
/*DARK MODE */
.dark .navContainer {
  background-color: var(--yungo-darkmode-background) !important;
}

.dark #title,
.dark .navContainer nav ul section div button div,
.dark .navContainer nav ul section div button i,
.dark .extraBtns,
.dark .dropdown-item,
.dark #mobileTitle,
.dark .dropdown-item:hover {
  color: white !important;
}

.dark .categoryBtn:hover,
.dark .extraBtns:hover {
  background: var(--yungo-primary-button) !important;
}

.dark .dropdown-item:active,
.dark .dropdown-item:focus,
.dark .dropdown-item:hover {
  background: var(--yungo-darkmode-subcategory-active) !important;
  color: white !important;
}

.dark .dropdown-menu.show {
  background: var(--yungo-darkmode-subcategory) !important;
}

.dark .mobileNav .navbar-toggler-icon {
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

/* .dark .activeItem {
  display: none;
} */

.dark .categoryBtn:focus .activeItem {
  display: none;
}

/* */

.activeItem {
  display: none;
}

.light .categoryBtn:focus .activeItem {
  display: inline-block;
}

.light .categoryBtn:focus .defaultItem {
  display: none;
}

.mobileNav {
  width: 95vw;
}

button.navbar-toggler {
  width: 50px;
  border: none;
}

.mobileNav .categoryBtn {
  margin: 0;
  width: 100%;
}

.mobileNav .dropdown-item,
.mobileNav .extraBtns {
  width: 100%;
  text-align: center;
}

:deep(p#userName) {
  color: black;
}

#userProfilePicture {
  margin-top: 10px;
}

#userProfilePicture img {
  width: 70px;
  height: 75.5px;
  border-radius: 50%;
  background-size: contain;
}

#userName {
  padding-left: 14px;
  height: 26px;
  width: 137px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 26px;
}

.categoryBtn img,
.dropdown-item img,
.extraBtns img {
  margin-right: 10px;
  width: 17px;
  margin-top: auto;
  margin-bottom: auto;
}

.gsc-control-cse {
  background-color: inherit !important;
  border: inherit !important;
  padding: inherit !important;
}

.dropdown-item:focus {
  display: block;
}

/* TODO: Create animation for dropdown opening */
.dropdown-menu.show {
  position: relative !important;
  transform: inherit !important;
  top: 0px;
  left: 0px;
  margin-bottom: 1em;
  will-change: transform;
  z-index: 1;
  border: none;
  margin-top: 10px;
  border-radius: 10px;
  padding: 0;
}

.dropdown-item:active {
  background: #f7f3ff !important;
  color: #8436ff !important;
}

.dropdown-toggle::after {
  margin-left: 2em;
}

.desktopNav {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: auto;
}

.desktopNav .btn {
  background-color: transparent;
  color: black;
}

#title {
  color: #070014;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  margin-top: 34px;
  margin-left: 0 !important;
}

button {
  border-radius: 10px;
  width: 255px;
  padding: 10px;
  text-align: start;
}

.categoryBtn:hover,
.extraBtns:hover {
  background-color: #f7f3ff;
  color: #8436ff;
}

/* .categoryBtn:hover:focus {
  color: white;
} */

/* .categoryBtn:active {
  background: #e1d6f6;
} */

.navbar-toggler > .close {
  display: inline;
}

.navbar-toggler.collapsed > .close,
.navbar-toggler:not(.collapsed) > .navbar-toggler-icon {
  display: none;
}

.categoryBtn:focus,
.extraBtns:focus {
  box-shadow: none;
  background-color: #8436ff !important;
  color: white;
}

.dropdown-item:focus {
  background-color: #e1d6f6 !important;
  color: #8436ff !important;
}

.dropdown-item:hover {
  color: #8436ff !important;
  background-color: #e1d6f6 !important;
}

.dropdown-menu {
  background-color: #f7f3ff;
  z-index: 0;
}

.dropdown-item {
  width: 255px;
  border-radius: 10px;
  padding: 10px;
}

.navContainer {
  padding-top: 50px;
  height: 95vh;
  display: flex;
}

.navitem {
  font-weight: 500;
  padding: 0px 20px 0px 0;
  font-size: 17px;
  letter-spacing: 0;
  line-height: 22px;
}

#mobileTitle {
  color: #070014;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  margin-top: 34px;
  font-size: inherit;
  margin: auto;
}

.mobileNav button.btn.d-flex.justify-content-between.categoryBtn {
  justify-content: center !important;
}

.mobileNav .dropdown button div {
  margin-right: 10px;
}

.allNavItems {
  min-height: 50vh;
  max-height: 50vh;
  overflow-y: auto;
}

@media only screen and (max-width: 992px) {
  li {
    list-style: none;
  }

  .navContainer {
    padding-top: 0;
    height: inherit;
    display: block;
  }

  .navitem {
    padding: 0 !important;
  }
}

@media only screen and (max-width: 1180px) {
  nav ul {
    padding: 0 !important;
  }

  h1 {
    margin-left: inherit !important;
  }
}
</style>

